import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PageNotFound from './components/PageNotFound';
import CavePage from './pages/CavePage';
import CarbonSeries from './pages/CarbonSeries';
import PostPage from './pages/PostPage';
import PostWisdom from './pages/PostWisdom';
import PostCarbonInteraction from "./pages/PostCarbonInteraction";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/" element={<CavePage/>}/>
            <Route path="/carbon-series" element={<CarbonSeries/>}/>
            <Route path="/carbon-series-visualization" element={<PostPage/>}/>
            <Route path="/wisdom-of-odds" element={<PostWisdom/>}/>
            <Route path="/carbon-series-interaction" element={<PostCarbonInteraction/>}/>
            <Route path='*' element={<PageNotFound/>} />
          </Routes>
        </div>
      </Router>      
    </div>
  );
}

export default App;
